<script setup>
import { computed } from 'vue'
import { stateLabel } from '@/utils/rules'

const props = defineProps({
  state: { type: String, required: true },
  icon: { type: String, default: 'shield-halved' },
  /** 是否附带英文状态码。日志、接口里用的是英文码，
   *  排查时需要能对上，所以默认显示。 */
  showCode: { type: Boolean, default: true },
})

// 五态机配色由 CSS 变量统一提供，避免每处各写一套颜色判断
const color = computed(() => `var(--st-${props.state})`)
const label = computed(() => stateLabel(props.state))
</script>

<template>
  <span class="state-tag" :style="{ color }">
    <FaIcon :icon="['fas', icon]" />
    {{ label }}
    <span v-if="showCode" class="code">{{ state }}</span>
  </span>
</template>

<style scoped>
/* 等宽字体的行高与正文不同，不显式对齐会把胶囊撑高一两像素 */
.code {
  font-family: var(--mono);
  font-size: 0.5625rem;
  line-height: 1;
  opacity: 0.6;
  font-weight: 600;
}
</style>
